var App = App || {};

App.Base = (function ($) {
    'use strict';

    let bsElements = {};

    let modals = [];
    let modalFlag = false;

    const speedBump = $("#SpeedBump");
    let speedBumpExempt = typeof SpeedbumpData !== 'undefined' ? [...SpeedbumpData.ExemptList] : [];

    function BsElements() {

        bsElements = {
            accElements: [...$("[data-bs-toggle='collapse']")].filter(x => x.getAttribute("data-bs-target") != "").map(x => x.getAttribute("data-bs-target")),
            tabElements: [...$("[data-bs-toggle='tab']")].filter(x => x.getAttribute("id") != "").map(x => `#${x.getAttribute("id")}`),
            offcanvasElements: [...$(".offcanvas")].filter(x => x.getAttribute("id") != "").map(x => `#${x.getAttribute("id")}`)
        };

        const hash = location.hash;
        BsElementsExecute(hash);
    }

    function BsElementsExecute(candidate) {

        let bsType = false;

        for (const key in bsElements) {
            if (bsElements[key].includes(candidate)) {
                bsType = key;
            }
        }

        if (bsType == false)
            return false;

        if (bsType == "accElements") {
            const collapse = $(candidate);
            collapse.collapse("show").parents(".accordion-item").find(`[data-bs-target=\"${candidate}\"]`).trigger("focus");
            $("html, body").animate({ scrollTop: collapse.offset().top }, 200);
        }
        else if (bsType == "tabElements") {
            const tab = $(candidate);
            tab.tab("show").trigger("focus");
            $("html, body").animate({ scrollTop: tab.offset().top }, 200);
        }
        else if (bsType == "offcanvasElements") {
            const offcanvas = $(candidate);
            offcanvas.offcanvas("show");
        }

        return true;
    }

    function Modals() {

        $.ajax({
            type: "GET",
            url: "/Api/Modals/GetModalUrls",
            success: function (result) {
                modals = [...result];
                const href = location.hash.replace("#", "/").toLowerCase();
                ModalsExecute(href, null);
            }
        })
    }

    function ModalsExecute(href, clicked) {

        if (href !== "" && modals.includes(href))
            href = href;
        else
            return false;

        $.ajax({
            type: "GET",
            url: href,
            success: function (result) {

                const modalData = {
                    "id": $(result).filter(".modal").attr("id"),
                    "content": $(result).filter(".modal").prop("outerHTML")
                };

                $("body").append(modalData.content);
                const modal = $(`#${modalData.id}`);

                App.Base.ClickSupport(modal.find("a"));
                modal.modal("show").on("hidden.bs.modal", function () {
                    if (clicked !== null) {
                        clicked.trigger("focus").trigger("blur");
                    }
                    if (!modalFlag) {
                        $(this).remove();
                    }
                });

            }
        });

        return true;
    }

    function SpeedBumpExecute(clicked) {

        const hostname = clicked[0].hostname;
        const href = clicked.attr("href");

        if (hostname === location.hostname || $.inArray(hostname, speedBumpExempt) !== -1 || !href || IsUriSchema(href)) {
            return false;
        }

        // check to see if speedbump was triggered from a modal
        const modalParent = clicked.parents(".modal").first();
        modalFlag = modalParent.length != 0;
        modalParent.modal("hide");

        speedBump.modal("show");
        speedBump.find("button[data-speedbump='proceed']")
            .off("click")
            .on("click", function () {
                speedBump.modal("hide");
                window.open(href);
            }
        );

        speedBump.on("hidden.bs.modal", function () {
            clicked.trigger("focus").trigger("blur");
            if (modalFlag) {
                modalParent.modal("show");
                modalFlag = false;
            }
        });

        return true;

    }

    function ClickSupport(selector) {

        selector.on("click", function (e) {

            const href = $(this).attr("href");

            if (CopyToClipboardExecute($(this)) == true) {
                e.preventDefault();
                return false;
            }

            if (BsElementsExecute(href) == true)
                return false;

            if (ModalsExecute(href, $(this)) == true) {
                e.preventDefault();
                return false;
            }

            if (SpeedBumpExecute($(this)) == true) {
                e.preventDefault();
                return false;
            }
        });
    }

    function IsUriSchema(href) {

        const uriSchemes = ["javascript:", "mailto:", "tel:"];

        for (var i in uriSchemes) {
            if (href.indexOf(uriSchemes[i]) > -1) {
                return true;
            }
        }
        return false;
    }

    function RichTextResponsiveTables(selector) {
        selector.each(function () {
            if (!$(this).parent().hasClass("table-responsive")) {
                $(this).wrap("<div class=\"table-responsive\"></div>")
            }
        });
    }

    function CopyToClipboardExecute(clicked) {
        if (!clicked.hasClass("copy")) {
            return false;
        }

        const textToCopy = clicked.find(".text").length ? clicked.find(".text").text().trim() : clicked.text().trim();

        if (!textToCopy) {
            return false;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy).then(function () {
                ShowCopyFeedback(clicked);
            }).catch(function (err) {
                console.error("Failed to copy: ", err);
            });
        } else {
            const textArea = document.createElement("textarea");

            textArea.value = textToCopy;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";

            document.body.appendChild(textArea);
            textArea.select();

            try {
                document.execCommand('copy');
                ShowCopyFeedback(clicked);
            } catch (err) {
                console.error("Failed to copy: ", err);
            }

            document.body.removeChild(textArea);
        }

        return true;
    }

    function ShowCopyFeedback(element) {
        const originalTitle = element.attr("title") || "";
        const tooltipInstance = bootstrap.Tooltip.getInstance(element[0]);

        if (tooltipInstance) {
            tooltipInstance.dispose();
        }

        element.attr("data-bs-original-title", "Copied!")
            .attr("title", "Copied!");

        const tooltip = new bootstrap.Tooltip(element[0], {
            trigger: "manual"
        });

        tooltip.show();

        setTimeout(function () {
            tooltip.hide();

            setTimeout(function () {
                tooltip.dispose();

                if (originalTitle) {
                    element.attr("title", originalTitle);
                } else {
                    element.removeAttr("title").removeAttr("data-bs-original-title");
                }
            }, 200);
        }, 1500);
    }

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };


    return {
        BsElements: BsElements,
        Modals: Modals,
        ClickSupport: ClickSupport,
        RichTextResponsiveTables: RichTextResponsiveTables,
        GetUrlParameter: GetUrlParameter
    };

})(jQuery);

$(function () {
    App.Base.BsElements();
    App.Base.Modals();
    App.Base.ClickSupport($("a"));
    App.Base.RichTextResponsiveTables($(".rich-text table.table"));
});